/**
 * Shared UI utility functions.
 *
 * ── Z-Index Layer Order ──────────────────────────────────────
 * These are the z-index values used across the UI system.
 * Keeping them documented here to avoid collisions.
 *
 *   30  — Bomb carrier indicator (bomb-hud.ts)
 *   42  — Bomb planted HUD (bomb-hud.ts)
 *   45  — Plant/defuse progress bar (bomb-hud.ts)
 *   50  — Chat container (chat.ts)
 *   56  — Registration dialog (registration-dialog.ts)
 *   57  — Leaderboard panel (leaderboard-panel.ts)
 *   60  — Buy menu overlay (buy-menu.ts)
 *   65  — Radio menu (chat.ts)
 *   70  — Settings menu overlay (settings-menu.ts)
 *   80  — End screen overlay (end-screen.ts)
 *  150  — Matchmaking overlay (matchmaking.ts)
 *  200  — Auth screen (auth-screen.ts)
 * 9999  — Rotate overlay (rotate-overlay.ts)
 * ─────────────────────────────────────────────────────────────
 */

/**
 * Escape HTML special characters to prevent XSS when inserting
 * user-supplied text into innerHTML or similar contexts.
 */
export function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
